import { resolveLocalized } from '@/i18n/resolveLocalized'
import type { GenreTemplate, Project } from '@/types/nf'

export function resolveProjectGenreLabel(project: Project, templates: GenreTemplate[] | undefined, lang: string) {
	 if (project.genre === 'other_custom' && project.genre_label_custom?.trim()) return project.genre_label_custom.trim()
  if (!project.genre) return ''
  const template = templates?.find((item) => item.genre_key === project.genre)
  return template ? resolveLocalized(template.payload.genre_label, lang) : ''
}
